import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import backendUrl from "../BackendUrl";
import "../styles/VerifyEmail.css";

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");

  useEffect(() => {
    if (!email) {
      navigate('/'); // or show an error
    }
  }, [email, navigate]); 

  const [codeSent, setCodeSent] = useState(false);
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");

  const sendCode = async () => {
    try {
      await axios.post(`${backendUrl}/api/accounts/send-verification`, { email });
      setCodeSent(true);
      setMessage("Verification code sent. Please check your email.");
    } catch (err) {
      setMessage(err.response?.data?.message || "Error sending verification code.");
    }
  };

  const verifyCode = async () => {
    try {
        await axios.post(`${backendUrl}/api/accounts/verify-code`, { email, code });
        setMessage("✅ Your email is verified! Redirecting...");
        
        // Redirect after a short delay
        setTimeout(() => {
        navigate("/");
        }, 1500);  // 1.5 seconds so user sees success message

    } catch (err) {
        setMessage(err.response?.data?.message || "Error verifying code.");
    }
  };


  return (
    <div className="verify-container">
      <div className="verify-card">
        <h2>Verify Your Email</h2>
        <p className="verify-email">{email}</p>

        {!codeSent ? (
          <button className="verify-button" onClick={sendCode}>
            Send Verification Email
          </button>
        ) : (
          <>
            <input
              type="text"
              placeholder="Enter 6-digit code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="verify-input"
            />
            <button className="verify-button" onClick={verifyCode}>
              Verify Code
            </button>
          </>
        )}

        {message && <p className="verify-message">{message}</p>}
      </div>
    </div>
  );
};

export default VerifyEmail;